/** A Date as a local YYYY-MM-DD (never toISOString, which is UTC and lands a day early ahead of UTC). */
export const localISO = (d: Date) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
